import { render, staticRenderFns } from "./CaledonianRoadArticle.vue?vue&type=template&id=7398104b&"
import script from "./CaledonianRoadArticle.vue?vue&type=script&lang=js&"
export * from "./CaledonianRoadArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports